import { useLocation } from 'wouter';
import { Camera, Clock, MapPin } from 'lucide-react';
import StatusBadge from './StatusBadge';
import type { PromoterOverview } from '../../hooks/use-team-overview';

export default function PromoterCard({ promoter }: { promoter: PromoterOverview }) {
  const [, setLocation] = useLocation();
  const { name, status, current_store, route_progress, today_stats } = promoter;

  let subtitle = 'Não iniciou';
  if (status === 'finished') subtitle = 'Finalizado';
  else if (status === 'in_transit') subtitle = 'Em deslocamento';
  else if (current_store) subtitle = current_store.name;

  return (
    <button
      onClick={() => setLocation(`/supervisor/team/${promoter.promoter_id}`)}
      className="w-full text-left bg-white rounded-xl border border-gray-100 p-4 active:bg-gray-50 transition-colors"
    >
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center text-primary font-semibold text-sm">
            {name.charAt(0)}
          </div>
          <span className="font-medium text-gray-900 text-sm">{name}</span>
        </div>
        <StatusBadge status={status} />
      </div>

      <div className="flex items-center gap-1 text-gray-500 text-xs mb-1.5">
        <MapPin size={12} />
        <span>{subtitle}</span>
      </div>

      <div className="flex items-center gap-3 text-xs text-gray-400">
        <span>{route_progress.visited}/{route_progress.total} lojas</span>
        {current_store && (
          <>
            <span className="flex items-center gap-0.5">
              <Clock size={11} /> {current_store.duration_minutes}min
            </span>
            <span className="flex items-center gap-0.5">
              <Camera size={11} /> {current_store.photo_count}
            </span>
          </>
        )}
        {today_stats.avg_score !== null && (
          <span>Score {today_stats.avg_score}</span>
        )}
      </div>
    </button>
  );
}
